import { render } from "./VoucherView.vue?vue&type=template&id=11a53c44&ts=true"
import script from "./VoucherView.vue?vue&type=script&lang=ts"
export * from "./VoucherView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@4.9.5__webpack@5.109.2_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__